import React from 'react';

import { useFormikContext } from 'formik';
import { useRecoilValue } from 'recoil';

import { formatDate } from 'lib/helpers/utility';

import { currentPractice } from 'components/practice/practiceState';
import DatePicker from 'components/shared/DatePicker/DatePicker';

const ExportDateRange = () => {
  const practice = useRecoilValue(currentPractice);
  const { values, setFieldValue } = useFormikContext();

  const handleChange = (value) => {
    setFieldValue(
      'title',
      `Calendar Export ${value.map((item) => formatDate(item, practice.timezone)).join(' - ')}`
    );
    setFieldValue('export_range', value);
  };

  return (
    <DatePicker
      parentClassName="grow"
      label="Export Date Range"
      name
      value={values.export_range}
      onChange={handleChange}
      isRange
      isClearable={false}
    />
  );
};

export default ExportDateRange;
